import { isAdminNotConsultant } from "@/js/http/auth.js";
import AdminRegionsSubMenusLinks from "@/components/menu/sub-menus/regions/AdminRegionsSubMenusLinks.vue";
import RegionListComponent from "@/components/region/RegionListComponent.vue";
export default {
  name: "adminRegionList",
  components: {
    AdminRegionsSubMenusLinks: AdminRegionsSubMenusLinks,
    RegionListComponent: RegionListComponent
  },
  props: ["loggedUserData"],
  data: function data(_this) {
    return {
      selectedTab: null,
      tabs: {
        wines: "wines",
        spirits: "spirits"
      }
    };
  },
  created: function created() {
    this.selectedTab = this.$route.query.tab || this.tabs.wines;
  },
  methods: {
    tabChanged: function tabChanged(tab) {
      this.selectedTab = tab;
    },
    isAdminNotConsultant: isAdminNotConsultant
  }
};